(() => {
  if (customElements.get('hero-slider')) {
    return;
  }

  class HeroSlider extends HTMLElement {
    constructor() {
      super();

      this.slider = {};
      this.controls = this.querySelectorAll('[data-control]');

      this.viewportWidth = window.innerWidth;
      [
        'shopify:section:load',
        'load',
        'resize'
      ].forEach((event) => {
        window.addEventListener(event, () => {
          if (event == 'resize' && window.innerWidth == this.viewportWidth) return;
          this.viewportWidth = window.innerWidth;
          this.calcHeight();
        });
      });
    }

    connectedCallback() {
      const autoplayEnabled = this.dataset.autoplay === 'true';

      this.slider = new Swiper(this, {
        loop: true,
        effect: 'slide',
        preventClicks: false,
        autoplay: autoplayEnabled ? {
          delay: Number(this.dataset.autoplayInterval),
          disableOnInteraction: false,
        } : false,
        navigation: {
          nextEl: '.hero__arrow-next',
          prevEl: '.hero__arrow-prev',
        },
        on: {
          init: () => {
            this.addAnimationHanler();
            this.updateImageClasses();
            this.handleVideoPlayback();
          },
          slideChange: () => {
            this.addFadeAnimations();
          },
          slideChangeTransitionEnd: () => {
            this.handleVideoPlayback();
          },
        },
      });
    }

    addAnimationHanler() {
      this.querySelectorAll('[data-fade-in]')?.forEach((element) => {
        element.addEventListener('animationend', () => {
          this.addFadeAnimations();
        })
      })
    }

    updateImageClasses() {
      const lazyloadImages = this.querySelectorAll('.lazyloading');
      
      lazyloadImages?.forEach(lazyloadImage => {
        lazyloadImage.classList.remove('lazyloading')
        lazyloadImage.classList.add('lazyloaded')
      })
    }

    addFadeAnimations() {
      this.animatedElements = this.querySelectorAll('[data-fade-in]');
      
      this.animatedElements.forEach((element) => {
        element.classList.add('fade-in');
      })
    }

    handleVideoPlayback() {
      // Pause all videos first
      const allVideos = this.querySelectorAll('video');
      
      allVideos.forEach((video, index) => {
        if (!video.paused) {
          video.pause();
        }
      });

      // Find the active slide using multiple methods for better reliability
      let activeSlide = this.querySelector('.swiper-slide-active');
      
      // Fallback: if no active slide found, use slider's active index
      if (!activeSlide && this.slider && this.slider.slides) {
        activeSlide = this.slider.slides[this.slider.activeIndex];
      }
      
      if (!activeSlide) {
        return;
      }

      // Find visible videos in the active slide
      const activeVideos = activeSlide.querySelectorAll('video');
      
      // Find and play only the first visible video to avoid multiple videos playing
      let videoPlayed = false;
      
      activeVideos.forEach((video, index) => {
        // Check if video is visible (not hidden by responsive classes)
        const isVisible = this.isVideoVisible(video);
        
        if (isVisible && !videoPlayed) {
          // Play the video
          video.currentTime = 0; // Reset to beginning
          const playPromise = video.play();
          videoPlayed = true; // Mark that we've played a video
          
          // Handle play promise for modern browsers
          if (playPromise !== undefined) {
            playPromise.catch(error => {
              // Silent error handling for autoplay issues
            });
          }
        }
      });
    }

    isVideoVisible(video) {
      // Check if video has responsive classes that would hide it
      const classList = video.classList;
      const windowWidth = window.innerWidth;
      
      // Check for hide classes based on screen size
      if (windowWidth <= 749) {
        // Mobile view - hide if has small-hide or medium-hide
        return !classList.contains('small-hide') && !classList.contains('medium-hide');
      } else if (windowWidth <= 989) {
        // Tablet view - hide if has medium-hide
        return !classList.contains('medium-hide');
      } else {
        // Desktop view - hide if has large-up-hide
        return !classList.contains('large-up-hide');
      }
    }



    calcHeight() {
      const announcementBar = document.querySelector('.section--announcement-bar:not(.section--header + .section--announcement-bar)');
      const announcementBarHeight = announcementBar ? announcementBar.offsetHeight : 0;

      if (announcementBarHeight <= 0) {
        return;
      }

      const headerElement = document.querySelector('.section--header');
      const headerHeight = headerElement ? headerElement.offsetHeight : 0;
      const headerOffset = announcementBarHeight + headerHeight;

      const heroBlocks = this.querySelectorAll('.hero__block');
      
      heroBlocks.forEach((element, index) => {
        const heroHeight = element.dataset.heroHeight;
        const newHeight = window.innerWidth > 989
          ? 'auto'
          : `calc(${heroHeight}vmax - ${headerOffset}px)`;
          
        element.style.height = newHeight;
      });
    }
  }

  customElements.define('hero-slider', HeroSlider);
})();
